import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import displayNames from '../displayNames';
import { ChevronDown } from '../../icons';
import CustomScroll from 'react-custom-scroll';
var dropDownBaseOptions = /*#__PURE__*/function (_React$Component) {
  function dropDownBaseOptions(props) {
    var _this;
    _classCallCheck(this, dropDownBaseOptions);
    _this = _callSuper(this, dropDownBaseOptions, [props]);
    _this.onOptionsMouseLeave = function () {
      if (_this.props.onOptionsMouseLeave) {
        _this.props.onOptionsMouseLeave();
      }
      _this.props.registerLastWindowScrollPosition();
    };
    return _this;
  }
  _inherits(dropDownBaseOptions, _React$Component);
  return _createClass(dropDownBaseOptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.registerOptions(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.registerOptions(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$optionsIn;
      var props = {
        onScroll: this.props.onScroll,
        ref: 'optionsInner'
      };
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId ? this.props.automationId + '_options_container' : null,
        "data-hook": this.props.dataHook ? this.props.dataHook + '_options_container' : null,
        className: 'dropdown-options-container ' + (this.props.optionsContainerClassName || ''),
        onClick: this.props.onClick,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave
      }, /*#__PURE__*/React.createElement("div", {
        className: "dropdown-options ".concat(this.props.displayPopoverArrow ? 'with-popover-arrow' : ''),
        ref: "options",
        style: this.props.optionsStyle,
        onMouseLeave: this.onOptionsMouseLeave,
        key: "options"
      }, this.props.displayArrow && this.props.arrows.up ? /*#__PURE__*/React.createElement("div", {
        className: "dropdown-arrow-up",
        onMouseEnter: this.props.scrollOptions.bind(this, -1),
        onMouseLeave: this.props.cancelOptionsScroll,
        key: "arrowUp"
      }, /*#__PURE__*/React.createElement(ChevronDown, null)) : null, this.props.showCustomScroll ? /*#__PURE__*/React.createElement(CustomScroll, _extends({
        handleClass: "dropdown-inner-handle",
        heightRelativeToParent: (_this$props$optionsIn = this.props.optionsInnerStyle.height) !== null && _this$props$optionsIn !== void 0 ? _this$props$optionsIn : '100%'
      }, props), this.props.options) : /*#__PURE__*/React.createElement("div", _extends({
        className: "dropdown-options-inner",
        style: this.props.optionsInnerStyle
      }, props), this.props.options), this.props.displayArrow && this.props.arrows.down ? /*#__PURE__*/React.createElement("div", {
        className: "dropdown-arrow-down",
        onMouseEnter: this.props.scrollOptions.bind(this, 1),
        onMouseLeave: this.props.cancelOptionsScroll,
        key: "arrowDown"
      }, /*#__PURE__*/React.createElement(ChevronDown, null)) : null), this.props.blockClickOutside ? /*#__PURE__*/React.createElement("div", {
        className: "block-click-outside",
        ref: "blockClickOutside",
        onClick: this.props.onClickOutside,
        key: "blockClick"
      }) : null);
    }
  }]);
}(React.Component);
dropDownBaseOptions.displayName = displayNames.DROP_DOWN_BASE_OPTIONS;
dropDownBaseOptions.propTypes = {
  registerOptions: PropTypes.func.isRequired,
  scrollOptions: PropTypes.func,
  onScroll: PropTypes.func,
  cancelOptionsScroll: PropTypes.func,
  onClickOutside: PropTypes.func,
  registerLastWindowScrollPosition: PropTypes.func,
  optionsStyle: PropTypes.object,
  optionsInnerStyle: PropTypes.object,
  arrows: PropTypes.object,
  displayArrow: PropTypes.bool,
  displayPopoverArrow: PropTypes.bool,
  blockClickOutside: PropTypes.bool,
  onClick: PropTypes.func,
  showCustomScroll: PropTypes.bool
};
export default dropDownBaseOptions; // DO NOT COMPOSE! Refs must be kept